module.exports = __webpack_public_path__ + "static/Muli-Black.6d782a98.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-Black.ttf
// module id = 328
// module chunks = 114276838955818